import React from "react";
import { useNavigate } from "react-router-dom";

const AnkleFootPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .af-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #f0f9ff 0, #f8fafc 40%, #e2e8f0 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .af-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .af-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(59, 130, 246, 0.18), rgba(96, 165, 250, 0.08));
          margin-bottom: 40px;
          display: grid;
          grid-template-columns: minmax(0, 1.4fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .af-hero {
            grid-template-columns: 1fr;
          }
        }

        .af-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(59, 130, 246, 0.22);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .af-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #3b82f6;
        }

        .af-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .af-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .af-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .af-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: white;
          font-size: 11px;
        }

        .af-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .af-btnPrimary,
        .af-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: 0.12s ease;
        }

        .af-btnPrimary {
          background: #3b82f6;
          color: white;
          box-shadow: 0 10px 24px rgba(59, 130, 246, 0.35);
        }

        .af-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(59, 130, 246, 0.45);
        }

        .af-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.6);
        }

        .af-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .af-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .af-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* STRIPES */
        .af-stripe {
          padding: 36px 0;
          border-bottom: 1px solid rgba(148,163,184,0.3);
        }

        .af-sectionTitle {
          font-size: 22px;
          font-weight: 800;
          margin-bottom: 10px;
        }

        .af-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 20px;
        }

        .af-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .af-flexCol {
          flex: 1 1 260px;
        }

        .af-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.15);
        }

        /* LIST */
        .af-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .af-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .af-bullet {
          width: 7px;
          height: 7px;
          background: #3b82f6;
          border-radius: 999px;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* WIDE CARD BAR */
        .af-wideCard {
          margin: 30px 0;
          padding: 22px;
          border-radius: 22px;
          background: rgba(15,23,42,0.03);
          box-shadow: 0 6px 20px rgba(15,23,42,0.08);
        }

        /* BANNER */
        .af-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 30px;
        }

        .af-banner img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          display: block;
        }

        .af-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.8), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .af-bannerText {
          color: #e0f2fe;
          font-size: 15px;
          max-width: 420px;
        }

        .af-bannerButtons {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .af-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .primary {
          background: #3b82f6;
          color: white;
        }

        .secondary {
          background: rgba(255,255,255,0.2);
          color: white;
          border: 1px solid rgba(255,255,255,0.5);
        }

      `}</style>

      <div className="af-page">
        <div className="af-inner">
          
          {/* HERO SECTION */}
          <section className="af-hero">
            <div>
              <div className="af-tag">
                <span className="af-tagDot" /> Ankle & Foot
              </div>

              <h1 className="af-title">Relieve foot & ankle pain so every step feels lighter.</h1>

              <p className="af-subtitle">
                Your foot and ankle work like your body’s shock absorbers. When the tibialis anterior,
                peroneals, or plantar fascia get irritated, every step can feel sharp, tight, or unstable.
              </p>

              <div className="af-chips">
                <span className="af-chip">Shin pain</span>
                <span className="af-chip">Plantar fascia tension</span>
                <span className="af-chip">Foot arch strain</span>
                <span className="af-chip">Toe fatigue</span>
              </div>

              <div className="af-ctaRow">
                <button className="af-btnPrimary" onClick={() => navigate("/appointments")}>
                  Book foot & ankle visit →
                </button>
                <button className="af-btnSecondary" onClick={() => navigate("/staff")}>
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="af-heroImgWrap">
              <img
                src="/content/ankle-foot/ankle_hero.png"
                className="af-heroImg"
                alt="Therapist assessing ankle and foot"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="af-stripe">
            <div className="af-sectionTitle">What can go wrong in the ankle & foot?</div>

            <div className="af-flexRow">
              <div className="af-flexCol">
                <ul className="af-list">
                  <li><span className="af-bullet" /> Shin tightness or soreness when walking or running</li>
                  <li><span className="af-bullet" /> Tibialis anterior irritation from overuse or new activity</li>
                  <li><span className="af-bullet" /> Outer-ankle pain from peroneal strain</li>
                  <li><span className="af-bullet" /> Rolling or instability during steps</li>
                  <li><span className="af-bullet" /> Foot arch fatigue or collapsing arches</li>
                  <li><span className="af-bullet" /> Plantar fascia tension or early morning foot pain</li>
                </ul>

                <div className="af-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="af-btnPrimary" onClick={() => navigate("/appointments")}>
                    See if this matches your symptoms →
                  </button>
                </div>
              </div>

              <div className="af-flexCol" style={{ textAlign: "center" }}>
                <img
                  src="/content/ankle-foot/ankle_tibialis.png"
                  className="af-img"
                  alt="Therapist treating front shin / tibialis anterior"
                />
              </div>
            </div>

            <div className="af-wideCard">
              <div className="af-sectionTitle">Key Areas We Treat</div>
              <ul className="af-list">
                <li><span className="af-bullet" /> **Tibialis Anterior** – lifts the foot and controls heel strike</li>
                <li><span className="af-bullet" /> **Plantar Fascia** – supports your arch and absorbs force</li>
                <li><span className="af-bullet" /> **Peroneals (Fibularis)** – stabilize the ankle from rolling</li>
                <li><span className="af-bullet" /> **Intrinsic Foot Muscles** – tiny stabilizers for balance & gait</li>
              </ul>
            </div>
          </section>

          {/* OUTER LEG / PERONEALS */}
          <section className="af-stripe">
            <div className="af-flexRow">
              <div className="af-flexCol">
                <img
                  src="/content/ankle-foot/ankle_peroneals.png"
                  className="af-img"
                  alt="Therapist working on outer lower leg (peroneals)"
                />
              </div>

              <div className="af-flexCol">
                <div className="af-sectionTitle">Outer Lower Leg (Peroneals)</div>
                <div className="af-sectionSubtitle">
                  These muscles prevent your ankle from rolling and help stabilize every step you take.
                </div>

                <ul className="af-list">
                  <li><span className="af-bullet" /> Pain on the outer shin or ankle</li>
                  <li><span className="af-bullet" /> Weakness causing “wobbly ankles”</li>
                  <li><span class="af-bullet" /> Discomfort with side-to-side movement</li>
                  <li><span class="af-bullet" /> Irritation after running or long walks</li>
                </ul>

                <div className="af-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="af-btnPrimary" onClick={() => navigate("/appointments")}>
                    Start foot & ankle PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="af-stripe">
            <div className="af-sectionTitle">How physical therapy helps your foot & ankle</div>
            <div className="af-flexRow">
              <div className="af-flexCol">
                <ul className="af-list">
                  <li><span className="af-bullet" /> **Soft-tissue treatment** to calm tight shin & arch muscles</li>
                  <li><span className="af-bullet" /> **Foot & ankle mobility work** for smoother walking</li>
                  <li><span className="af-bullet" /> **Arch stabilization training** for improved balance</li>
                  <li><span className="af-bullet" /> **Tendon loading programs** for patellar + plantar fascia issues</li>
                  <li><span className="af-bullet" /> **Gait retraining:** fix collapsing arches or overstriding</li>
                </ul>

                <div className="af-ctaRow" style={{ marginTop: "14px" }}>
                  <button className="af-btnPrimary" onClick={() => navigate("/appointments")}>
                    Fix my foot & ankle pain →
                  </button>
                  <button className="af-btnSecondary" onClick={() => navigate("/insurance")}>
                    Verify insurance
                  </button>
                </div>
              </div>

              <div className="af-flexCol" style={{ textAlign: "center" }}>
                <img
                  src="/content/ankle-foot/ankle_exercises.png"
                  className="af-img"
                  alt="Foot and ankle strengthening exercises"
                />
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="af-stripe">
            <div className="af-banner">
              <img
                src="/content/ankle-foot/ankle_banner.png"
                alt="Bright physical therapy clinic environment for foot and ankle care"
              />

              <div className="af-bannerOverlay">
                <div className="af-bannerText">
                  Your feet carry you everywhere — our job is to make every step feel natural,
                  supported, and pain-free.
                </div>

                <div className="af-bannerButtons">
                  <button className="primary" onClick={() => navigate("/appointments")}>
                    Schedule foot & ankle visit →
                  </button>

                  <button className="secondary" onClick={() => navigate("/office")}>
                    View our locations
                  </button>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default AnkleFootPT;
